import Subscription from "../../subscription/models/Subscription";
import HttpService from "../../core/services/HttpService";
import HttpCallConfig from "../../core/models/HttpCallConfig";
import { ISubscriptionStatistics } from "../models/SubscriptionStatistics";

interface IGetSubscriptionsResponse {
  subscriptions: Subscription[]
}

export const getSubscriptionsByAssetId = async (assetId: string, httpConfig: HttpCallConfig | undefined = undefined): Promise<Subscription[]> => {
  const response = await HttpService.Instance.get(`${process.env.REACT_APP_API_URL}subscriptions?assetId=${assetId}`, httpConfig);
  const getSubscriptionsResponse: IGetSubscriptionsResponse = await response.json();
  return getSubscriptionsResponse.subscriptions;
}

export const getSubscriptionStatistics = async (): Promise<ISubscriptionStatistics | undefined> => {
  const response = await HttpService.Instance.get(process.env.REACT_APP_API_URL + '/subscriptions/statistics');
  if (response.ok) {
    return response.json()
  } else {
    return undefined;
  }
}


// WEBPACK FOOTER //
// ./src/modules/shared/services/SubscriptionsApi.ts